<script setup>
import { computed } from 'vue';

import WootLabel from 'dashboard/components-next/label/Label.vue';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

const props = defineProps({
  result: { type: Object, required: true },
});

const { eventLabel, formatStatus, labelColor } =
  useAutomationOperationsFormatters();

const replayResultAttempts = computed(() => props.result?.attempts || []);
</script>

<template>
  <div
    class="mt-4 grid gap-3 border border-n-weak bg-n-surface-1 p-3"
    data-test="automation-replay-result"
  >
    <div class="flex flex-wrap items-center justify-between gap-3">
      <span class="text-heading-3 text-n-slate-12">
        {{ $t('AUTOMATION.OPERATIONS.REPLAY.TABLE_HEADER.RESULT') }}
      </span>
      <WootLabel
        :label="formatStatus(result.status)"
        :color="labelColor(result.status)"
        compact
      />
    </div>
    <div
      v-if="replayResultAttempts.length"
      class="grid gap-2 md:grid-cols-2 xl:grid-cols-3"
    >
      <div
        v-for="attempt in replayResultAttempts"
        :key="attempt.id"
        class="grid gap-1 rounded-md border border-n-weak px-3 py-2 text-body-main text-n-slate-11"
      >
        <div class="flex min-w-0 justify-between gap-2">
          <span class="truncate text-n-slate-12">
            {{ attempt.action_ref }}
          </span>
          <span class="tabular-nums">
            {{ eventLabel(attempt.attempt_number || attempt.id) }}
          </span>
        </div>
        <span>{{ formatStatus(attempt.result) }}</span>
        <span v-if="attempt.error_kind" class="truncate">
          {{ formatStatus(attempt.error_kind) }}
        </span>
      </div>
    </div>
  </div>
</template>
